import { Button, Box, Typography, TextField } from '@mui/material';
import { styled } from 'styled-components';
import { fontSizes } from '../../../layouts/fontSizes';
import DropdownSelect from '../../../components/DropdownSelect';
import MultiSelectWithAll from '../../../components/MultiSelectWithAll';

const StyledButton = styled(Button)`
  border-radius: 8px !important;
  width: 200px !important;
`;

const DialogFormColumn = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const DialogFormRow = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const DialogLabel = styled(Typography)`
  width: 170px !important;
  font-size: ${fontSizes.placeHolder} !important;
`;

const ConcessionsLabel = styled(DialogLabel)`
  line-height: 32px !important;
`;

const FlexGrowBox = styled(Box)`
  flex: 1;
  width: 100%;
`;

const menuPaperSx = { zIndex: (theme: any) => theme.zIndex.modal + 10 };
const buildSelectProps = (placeholder: string, renderFunction: any) => ({
  displayEmpty: true,
  renderValue: renderFunction,
  MenuProps: { disablePortal: true, PaperProps: { sx: menuPaperSx } }
});

const StyledTextField = styled(TextField)`
  width: 100% !important;
`;

const ActionButton = styled(Button)`
  border-radius: 8px !important;
  width: 200px !important;
`;

const RolloverActionsContainer = styled(Box)`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const StyledDropdown =styled(DropdownSelect)`
  width: 568px !important;
`;

const StyledMultiSelect = styled(MultiSelectWithAll)` 
  width: 568px !important;
`;

export {
  StyledButton,
  DialogFormColumn,
  DialogFormRow,
  DialogLabel,
  ConcessionsLabel,
  FlexGrowBox,
  buildSelectProps,
  StyledTextField,
  ActionButton,
  RolloverActionsContainer,
  StyledDropdown,
  StyledMultiSelect
};
